function ErrorMessage({ errMessage, className = "" }) {
  return (
    <span className={`error_msg ${className}`}>{errMessage}</span>

  );
}

export default ErrorMessage;
